import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaHome, FaUser, FaCogs, FaSignOutAlt, FaChartLine, FaStopwatch, FaUserShield, FaNewspaper, FaChalkboardTeacher, FaQuestionCircle, FaMoneyBill, FaHandshake, FaCalendarAlt, FaCalendarWeek } from 'react-icons/fa';
import axios from 'axios';
import LoadingSpinner from '../login/loading';
import { getAuthToken } from '../../authToken';

const Sidebar = ({ user, user_id, titre }) => {
  const [isAdminOpen, setIsAdminOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [groupeId, setGroupeId] = useState(null);
  const [isGroupeVerified, setIsGroupeVerified] = useState(false);
  const [eligibiliteExiste, setEligibiliteExiste] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const groupe = localStorage.getItem('groupe');
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const [accesGroupe, setAccesGroupe] = useState([]);
  const [parcours, setParcours] = useState([]);

  const toggleAdminMenu = () => {
    setIsAdminOpen(!isAdminOpen);
  };
  const Username = localStorage.getItem('Username');

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const toggleSubmenu = () => {
    setIsSubmenuOpen(!isSubmenuOpen);
  };

  const isActive = (path) => location.pathname.startsWith(path);

  const activeStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    color: 'white',
    borderLeft: '4px solid white',
  };

  const defaultStyle = {
    backgroundColor: 'transparent',
    borderLeft: 'none',
  };

  const navHeaderStyle = {
    marginBottom: '0',
    paddingTop: '0px',
    paddingBottom: '5px',
  };

  const sidebarStyle = {
    background: 'linear-gradient(to bottom, #273748, #28416F)',
    color: 'white',
  };

  const [formData, setFormData] = useState({});

  const fetchUtilisateur = async () => {
    try {
      const token = localStorage.getItem('access_token');

      const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}` // À inclure si nécessaire
        },
      });

      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const data = await response.json();
      setFormData(data);
      localStorage.setItem('userProfile', JSON.stringify(data));

    } catch (error) {
      console.error('Erreur lors de la récupération des données utilisateur', error);
    }
  };

  const verifGroupe = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}/`);
      if (response.status === 200) {
        const data = response.data;
        setGroupeId(data.groupe);

        let cleanedAccessArray = [];
        if (Array.isArray(data.acces)) {
          cleanedAccessArray = data.acces.map((item) =>
            item.acces
              ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
              : []
          ).flat();

          setAccesGroupe(cleanedAccessArray);
        }

        localStorage.setItem('groupe', data.groupe);
        localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
        setIsGroupeVerified(true);
      }
    } catch (error) {
      console.error('Erreur lors de la vérification du groupe', error);
    }
  };

  const verifGroupeDeLutilisateur = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOTE}/groupe-de-l-utilisateur/${user_id}/`);
      if (response.status === 200) {
        const data = response.data;
        localStorage.setItem('groupe', data.group_ids);
      }
    } catch (error) {
      console.error('Erreur lors de la vérification du groupe', error);
    }
  };

  useEffect(() => {
    if (user_id) {
      const loadData = async () => {
        setIsLoading(true);
        setShowSpinner(true);
        setFadeOut(false);

        try {
          // 1. Charger d'abord le profil utilisateur
          await fetchUtilisateur();

          // 2. Vérifier les groupes et accès
          await verifGroupe();

          // 3. Vérifier le groupe de l'utilisateur
          await verifGroupeDeLutilisateur();

        } catch (error) {
          console.error('Erreur lors du chargement des données:', error);

          // En cas d'erreur, essayer de récupérer depuis le cache
          const cachedProfile = localStorage.getItem('userProfile');
          const accesGroupeStored = localStorage.getItem('accesGroupe');
          const groupeStored = localStorage.getItem('groupe');

          if (cachedProfile) {
            setFormData(JSON.parse(cachedProfile));
          }
          if (accesGroupeStored) {
            setAccesGroupe(JSON.parse(accesGroupeStored));
          }
          if (groupeStored) {
            setGroupeId(groupeStored);
          }
        } finally {
          // D'abord déclencher l'animation de fade out
          setFadeOut(true);

          // Puis attendre la fin de l'animation avant de cacher complètement
          setTimeout(() => {
            setShowSpinner(false);
            setIsLoading(false);
          }, 500); // Durée de l'animation
        }
      };

      loadData();
    }
  }, [user_id]);

  // const handleLogout = () => {
  //   localStorage.clear();
  //   sessionStorage.clear();
  //   localStorage.removeItem('redirectAfterLogin');
  //   window.location.replace('/');
  // };

const handleLogout = async () => {
  try {
    const token = localStorage.getItem('access_token');
    const user_id = localStorage.getItem('user_id');

    const response = await fetch(`${process.env.REACT_APP_HOTE}/deconnexion/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        user_id: user_id
      })
    });

    const data = await response.json();

    // Sauvegarder les préférences cookies avant de tout supprimer
    const cookieConsent = localStorage.getItem('cookieConsent');
    const cookiePreferences = localStorage.getItem('cookiePreferences');
    const cookieConsentDate = localStorage.getItem('cookieConsentDate');

    // Supprimer les données locales (sauf les cookies)
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('accesGroupe');
    localStorage.removeItem('groupe');
    localStorage.removeItem('heureDebutExamen');
    localStorage.removeItem('heureFinExamen');
    localStorage.removeItem('answers');
    localStorage.removeItem('currentQcmIndex');
    localStorage.removeItem('examen_id_strored');
    localStorage.removeItem('answersRecap');
    localStorage.removeItem('isPaused');
    localStorage.removeItem('examStartTime');
    localStorage.removeItem('examPauseTime');
    localStorage.removeItem('totalPausedTime');
    localStorage.removeItem('pauseStartTime');
    localStorage.removeItem('remainingTimeBeforePause');
    localStorage.removeItem('redirectAfterLogin');

    // Restaurer les préférences cookies
    if (cookieConsent) localStorage.setItem('cookieConsent', cookieConsent);
    if (cookiePreferences) localStorage.setItem('cookiePreferences', cookiePreferences);
    if (cookieConsentDate) localStorage.setItem('cookieConsentDate', cookieConsentDate);

    sessionStorage.clear();

    // Rediriger vers la page de connexion
    window.location.href = '/';
  } catch (error) {
    console.error('Erreur réseau:', error);
    
    // En cas d'erreur, sauvegarder aussi les cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    const cookiePreferences = localStorage.getItem('cookiePreferences');
    const cookieConsentDate = localStorage.getItem('cookieConsentDate');
    
    localStorage.clear();
    
    if (cookieConsent) localStorage.setItem('cookieConsent', cookieConsent);
    if (cookiePreferences) localStorage.setItem('cookiePreferences', cookiePreferences);
    if (cookieConsentDate) localStorage.setItem('cookieConsentDate', cookieConsentDate);
    
    sessionStorage.clear();
    window.location.href = '/';
  }
};

  // Style pour le spinner qui couvre tout l'écran
  const spinnerFullscreenStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    transition: 'opacity 0.5s ease-out',
    opacity: fadeOut ? 0 : 1,
    pointerEvents: fadeOut ? 'none' : 'auto'
  };

  // Style pour la sidebar (s'adapte au chargement)
  const sidebarWrapperStyle = {
    // height: '100vh',
    position: 'relative',
    ...sidebarStyle
  };

  return (
    <>
      {/* Spinner plein écran */}
      {showSpinner && (
        <div style={spinnerFullscreenStyle}>
          <LoadingSpinner />
        </div>
      )}

      {/* La sidebar reste toujours visible */}
      <nav
        className="navbar-default navbar-static-side animated fadeInLeft"
        role="navigation"
        style={sidebarWrapperStyle}
      >
        <div className="sidebar-collapse">
          <ul className="nav metismenu" id="side-menu">
            <li className="nav-header" style={navHeaderStyle}>
              <div className="dropdown profile-element">
                <div
                  className="dropdown-toggle"
                  onClick={toggleProfileMenu}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="font-bold text-white"><h2>eTrainApp</h2></span>
                </div>
              </div>
            </li>

            {/* Menu Dashboard - Toujours visible */}
            <li style={isActive('/dashboard') ? activeStyle : defaultStyle}>
              <Link className='text-white' to={{
                pathname: `/dashboard`,
                state: { user, titre }
              }}>
                <FaHome /> <span className="nav-label ml-2">Dashboard</span>
              </Link>
            </li>

            {/* Les autres menus conditionnels */}
            {accesGroupe.includes('eligibilite') && (
              <li style={isActive('/eligibilite') ? activeStyle : defaultStyle}>
                <Link className='text-white' to={{
                  pathname: `/eligibilite`,
                  state: { user }
                }}>
                  <FaUserShield /> <span className="nav-label ml-2">Eligibilite</span>
                </Link>
              </li>
            )}

            {accesGroupe.includes('Apprentisage') &&
              <li style={
                isActive('/Parcours') ||
                  isActive('/Formulaire-avis-client') ||
                  isActive('/demarrer-qcm') ||
                  isActive('/Historique-evaluation') ||
                  isActive('/terminer-qcm') ? activeStyle : defaultStyle
              }>
                <Link className='text-white' to={{
                  pathname: `/Parcours`,
                  state: { user }
                }}>
                  <FaChartLine /> <span className="nav-label ml-2">Parcours</span>
                </Link>
              </li>
            }

            {accesGroupe.includes('ExamenBlanc') && (
              <li style={
                isActive('/Historique-complet') ||
                  isActive('/Demarrer') ||
                  isActive('/Terminer') ||
                  isActive('/Lancement-examen') ||
                  isActive('/Fin-examen') ||
                  isActive('/Recapitulatif-examen') ||
                  isActive('/Resultats-principe') ||
                  isActive('/Favoris') ? activeStyle : defaultStyle
              }>
                <Link className='text-white' to={{
                  pathname: `/Historique-complet`,
                  state: { user }
                }}>
                  <FaStopwatch /> <span className="nav-label ml-2">Simulateur</span>
                </Link>
              </li>
            )}

            {accesGroupe.includes('EtudeDeCas') && (
              <li style={
                isActive('/Etude-de-cas') ||
                  isActive('/Etude-demarrer') ||
                  isActive('/Resultats-etude') ? activeStyle : defaultStyle
              }>
                <Link className='text-white' to={{
                  pathname: `/Etude-de-cas`,
                  state: { user },
                }}>
                  <FaChalkboardTeacher /> <span className="nav-label ml-2">Etude de cas</span>
                </Link>
              </li>
            )}

            {accesGroupe.includes('Quiz') && (
              <li style={
                isActive('/Quizz-form') ||
                  isActive('/Quizz-demarrer') ||
                  isActive('/Quizz-terminer') ? activeStyle : defaultStyle
              }>
                <Link
                  className="text-white"
                  to={{
                    pathname: `/Quizz-form`,
                    state: { user },
                  }}
                >
                  <FaQuestionCircle /> <span className="nav-label ml-2">Quiz</span>
                </Link>
              </li>
            )}

            {accesGroupe.includes('Administration') && (
              <li style={
                isActive('/admin') ||
                  isActive('/Liste-groupe') ||
                  isActive('/Liste-utilisateur') ||
                  isActive('/Liste-produit') ||
                  isActive('/Liste-formation') ||
                  isActive('/Liste-qcm') ||
                  isActive('/Qcm-defaillants') ||
                  isActive('/Liste-eco') ||
                  isActive('/Liste-etude') ||
                  isActive('/Liste-diffusion') ||
                  isActive('/Liste-tag') ||
                  isActive('/Liste-parcours') ||
                  isActive('/Liste-domaine') ||
                  isActive('/Liste-notification') ||
                  isActive('/Liste-dictionnaire') ||
                  isActive('/Eligibilites-soumises') ||
                  isActive('/Eligibilite-admin') ||
                  isActive('/Modifier-produit') ||
                  isActive('/Modifier-groupe') ||
                  isActive('/Modifier-formation') ||
                  isActive('/Modifier-eco') ||
                  isActive('/Modifier-etude') ||
                  isActive('/Modifier-tag') ||
                  isActive('/Modifier-qcm') ||
                  isActive('/Modifier-domaine') ||
                  isActive('/Modifier-diffusion') ||
                  isActive('/Ajouter-groupe') ||
                  isActive('/Ajouter-produit') ||
                  isActive('/Ajouter-formation') ||
                  isActive('/Ajouter-diffusion') ||
                  isActive('/Ajouter-tag') ||
                  isActive('/Ajouter-eco') ||
                  isActive('/Ajouter-etude') ||
                  isActive('/Ajouter-qcm') ||
                  isActive('/Ajouter-domaine') ||
                  isActive('/ajouter-utilisateur-diffusion') ||
                  isActive('/Configuration-parcours') ||
                  isActive('/Configurer-groupe') ||
                  isActive('/Gestion-des-examens') ||
                  isActive('/Admin-Resultat-examen') ||
                  isActive('/Commercial') ||
                  isActive('/NewsLetters') ||
                  isActive('/Liste-partenaire') ||
                  isActive('/Liste-souscription-admin') ||
                  isActive('/Journal-paiement') ||
                  isActive('/Journalisation') ||
                  isActive('/ajouter-utilisateur-groupe') ||
                  isActive('/RDV-admin') ||
                  // isActive('/Booking-coach') ||
                  isActive('/Gestion-avis-client') ||
                  isActive('/Liste-inscription') ||
                  isActive('/Liste-specialite') ||
                  isActive('/Experience-form-admin') ? activeStyle : defaultStyle
              }>
                <Link className='text-white' to={{
                  pathname: `/admin`,
                  state: { user }
                }}>
                  <FaCogs /> <span className="nav-label ml-2">Administration</span>
                </Link>
              </li>
            )}

            {/* Menu Profil - Toujours visible */}
            <li style={isActive('/profil-utilisateur') ? activeStyle : defaultStyle}>
              <Link className='text-white' to={{
                pathname: `/profil-utilisateur`,
                state: { user, titre }
              }}>
                <FaUser /> <span className="nav-label ml-2">Mon Profil</span>
              </Link>
            </li>

            {/* FAQ - Toujours visible */}
            <li style={isActive('/FAQ') ? activeStyle : defaultStyle}>
              <Link className='text-white' to={{
                pathname: `/FAQ`,
                state: { user, titre }
              }}>
                <FaQuestionCircle /> <span className="nav-label ml-2">FAQ</span>
              </Link>
            </li>

            {accesGroupe.includes('UtilisateurPartenaire') && (
              <li style={isActive('/Page-partenaire') ? activeStyle : defaultStyle}>
                <Link
                  className="text-white"
                  to={{
                    pathname: `/Page-partenaire`,
                    state: { user },
                  }}
                >
                  <FaHandshake /> <span className="nav-label ml-2">Partenaire</span>
                </Link>
              </li>
            )}

            {accesGroupe.includes('CoachRdv') && (
              <li style={isActive('/Booking-coach') ? activeStyle : defaultStyle}>
                <Link
                  className="text-white"
                  to={{
                    pathname: `/Booking-coach`,
                    state: { user },
                  }}
                >
                  <FaCalendarWeek /> <span className="nav-label ml-2">Mes bookings</span>
                </Link>
              </li>
            )}

            {/* Menu Souscriptions - Condition modifiée pour être stable */}
            {formData.type_profil && formData.type_profil === 'Apprenant' && (
              <li style={isActive('/Souscription-utilisateur') || isActive('/Souscrire') ? activeStyle : defaultStyle}>
                <Link className='text-white' to={{
                  pathname: `/Souscription-utilisateur`,
                  state: { user, titre }
                }}>
                  <FaMoneyBill /> <span className="nav-label ml-2">Mes souscriptions</span>
                </Link>
              </li>
            )}

            {/* Déconnexion - Toujours visible */}
            <li className='ml-2' style={defaultStyle}>
              <Link
                onClick={handleLogout}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'white',
                  cursor: 'pointer',
                  width: '100%',
                  textAlign: 'left',
                  padding: '10px 15px',
                }}
              >
                <FaSignOutAlt /> <span className="nav-label ml-2">Déconnexion</span>
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Sidebar;